<article>
  <h4 class="pro-experience-title">
    <span *ngIf="model?.name" class="pro-experience-name">{{ model.name }}</span>
    <span *ngIf="(company$ | async)?.name" class="pro-experience-company" i18n
      >chez {{ (company$ | async)?.name }}</span
    >
  </h4>

  <div class="pro-experience">
    <span class="pro-experience-period">
      {{ model.startDate | date: 'MM-yyyy' }} - {{ model.inProgress ? '' : (model.endDate | date: 'MM-yyyy') }}
      <ng-container *ngIf="model.inProgress" i18n>Maintenant</ng-container>
    </span>

    <span class="pro-experience-location" *ngIf="(company$ | async)?.location?.short">
      <app-svg-icon
        class="pro-experience-icon"
        icon="localisation"
        label="Lieu du poste"
        i18n-label
        width=".75em"
      ></app-svg-icon>

      <span>{{ (company$ | async)?.location?.short }}</span>
    </span>

    <span class="pro-experience-specialities">
      <app-svg-icon class="pro-experience-icon" icon="tag" label="Spécialités" i18n-label width=".75em"></app-svg-icon>

      <app-i18n-domain [model]="model.domainId"></app-i18n-domain>
    </span>

    <span class="pro-experience-description">{{ model.description }}</span>
  </div>
</article>
